<template>
  <!-- 工队报价列表 -->
  <div class="tableList">
    <el-table
      :data="teamList"
      :header-cell-style="setColumnDataColor"
      :cell-style="setCellStyle"
      style="width: 100%"
      v-loading="loading"
    >
      <template slot="empty">
        <img src="@/static/img/cailiao.png" alt />
        <p class="noText" style="color:#000;fontSize:16px;">暂无数据</p>
      </template>
      <el-table-column align="center" prop="title" label="工程分类" show-overflow-tooltip width="240">
        <template slot-scope="scope">
          <!-- <span class="title-cli" @click="goToDetail(scope.row.id)">{{scope.row.firstCategoryName}}</span> -->
          <span>{{scope.row.firstCategoryName}}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="typeWork"
        label="工种名称"
        show-overflow-tooltip
        width="180"
      ></el-table-column>
      <el-table-column align="center" prop="unit" width="100" label="计量单位" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" label="包含材料" prop="publishTime" width="200" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.hasMaterial === 0">包含辅材:{{scope.row.material}}</div>
          <div v-if="scope.row.hasMaterial === 1">不包含辅材</div>
          <div v-if="scope.row.hasMaterial === 2" class="tow-table">
            <span>包含辅材：{{scope.row.material}}</span>
            <span>不含辅材</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="单位报价（元）" prop="status">
        <template slot-scope="scope">
          <div v-if="scope.row.hasMaterial === 0">{{scope.row.priceWithMaterial}}</div>
          <div v-if="scope.row.hasMaterial === 1">{{scope.row.price}}</div>
          <div v-if="scope.row.hasMaterial === 2" class="tow-table">
            <span>{{scope.row.priceWithMaterial}}</span>
            <span>{{scope.row.price}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="包含设备" prop="equipment" show-overflow-tooltip></el-table-column>
      <!-- <el-table-column align="center" label="报价单位" prop="teamName"></el-table-column> -->
    </el-table>
    <!-- <div
      v-if="teamList.length > 0"
      style="text-align: center;padding: 10px 0;background-color: #FFFFFF;margin-bottom: 20px;"
    >
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next, jumper"
        :page-size="param.page"
        :total="param.total"
        :current-page="param.limit"
      ></el-pagination>
    </div> -->
  </div>
</template>

<script>
import { setColumnDataColor, setCellStyle } from '@/views/Home/components/style.js'
export default {
  name: 'tableList',
  props: {
    teamList: {
      type: Array
    },
    param: {
      type: Object
    }
  },
  data () {
    return {
      setColumnDataColor,
      setCellStyle,
      loading: false,
      tableData: [],
      jData: {
        page: 1,
        limit: 20,
        totalRow: 0
      }
    }
  },

  components: {},
  created () {},

  methods: {
    handleCurrentChange () {
      this.$emit('handleCurrentChange', this.param)

    }
  }
}
</script>

<style lang="scss" scoped>
.tableList {
  .noData {
    width: 100%;
    margin-bottom: 50px;
    background: #ffffff;
    padding-bottom: 50px;
    padding-top: 50px;
    border: 1px solid #e4e7ed;
    border-radius: 0 0 4px 4px;
    border-top: none;
    box-sizing: border-box;
    .noDataImg {
      width: 177px;
      margin: 0 auto 15px;
      img {
        width: 100%;
      }
    }
    .noText {
      text-align: center;
      font-size: 18px;
      color: #333;
    }
  }
}
</style>
